import React from "react";
import { ProgressionTemplateWeek } from "../../libs/progression/types";
import { formatRepsDisplay } from "../../libs/progression/utils";

type Props = {
  weeks: ProgressionTemplateWeek[];
};

export const ProgressionWeeksPreview: React.FC<Props> = ({ weeks }) => {
  if (!weeks.length) return null;

  return (
    <div className="flex gap-2 overflow-x-auto">
      {weeks.map((week, i) => (
        <div
          key={i}
          className="flex-1 min-w-[110px] rounded-lg border border-gray-200 dark:border-gray-700 text-[0.6rem] px-2.5 py-2 text-center bg-white dark:bg-gray-800 text-gray-600 dark:text-gray-400"
        >
          <div className="text-[0.55rem] font-semibold uppercase text-gray-400 mb-1">
            Sett. {week.weekNumber}
          </div>
          {week.sets.length > 0 ? (
            <>
              <div className="flex justify-between font-semibold mb-0.5">
                <span>SET</span>
                <span>REPS</span>
                <span>REST</span>
              </div>
              {week.sets.map((set, si) => (
                <div key={si} className="flex justify-between">
                  <span>{si + 1}°</span>
                  <span>{formatRepsDisplay(set.reps, set.repsRange)}</span>
                  <span>{set.rest || "—"}</span>
                </div>
              ))}
            </>
          ) : (
            <span className="text-gray-300">—</span>
          )}
          {week.notes && (
            <div className="mt-1.5 pt-1 border-t border-gray-100 dark:border-gray-700 text-[0.55rem] text-gray-400 italic line-clamp-2 text-left">
              {week.notes}
            </div>
          )}
        </div>
      ))}
    </div>
  );
};
